import React, { Component } from 'react';
import { connect } from 'react-redux';
import Projectsidebar from '../projectsidebar/projectsidebar';
import Sidebar from '../sidebar/sidebar';
import {featuredImageWithFallback, imageWithFallback} from '../../utilities';
import ScrollbarArea from '../scrollbararea/scrollbararea';


import './project.css';
import has from "lodash.has";
import {Helmet} from "react-helmet";

class Project extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {

        let project = {
            title: "",
            content: ""
        };


        if (has(this,'props.projects.projects')) {
            let foundProject = this.props.projects.projects.find((project) => {
                return (project.slug === this.props.match.params.projectslug);
            });

            if (foundProject) {
                project = foundProject;
            }
        }

        let projectImage = featuredImageWithFallback(project, 'large');

        if (has(project, 'sidebar_afbeelding.sizes') && project.sidebar_afbeelding !== false && project.sidebar_afbeelding !== null) {
            projectImage = imageWithFallback(project.sidebar_afbeelding, 'large');
        }

        return (
            <div className="project">
                <Helmet>
                    <title>{project.title.rendered} - KWOOT</title>
                    <meta property="og:title" content={project.title.rendered + ' - KWOOT'} />
                    {projectImage && <meta property="og:image" content={projectImage} />}
                </Helmet>
                <Sidebar title={project.title.rendered} image={projectImage} description={project.sidebar_description} groupbuttontitle="Alle projecten" groupbuttonlink="/ons-werk"/>
                <ScrollbarArea
                    speed={0.8}
                    className="project__contentarea"
                    contentClassName="project__content"
                    horizontal={false}
                >
                    <div dangerouslySetInnerHTML={{__html: project.content.rendered}}></div>
                </ScrollbarArea>
                <Projectsidebar></Projectsidebar>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        projects: state.projects,
        projectsById: state.projectsById
    }
}

export default connect(mapStateToProps)(Project);



// WEBPACK FOOTER //
// ./src/components/project/project.js